import { render, staticRenderFns } from "./RoomInspection.vue?vue&type=template&id=236d86a4&"
import script from "./RoomInspection.vue?vue&type=script&lang=js&"
export * from "./RoomInspection.vue?vue&type=script&lang=js&"
import style0 from "./RoomInspection.vue?vue&type=style&index=0&id=236d86a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports